import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import Toggle from '../../Inputs/Toggle';
import Tip from '../../Tools/Tip';
import API from '../../../services/API/Rewards';
import useOptimisticDelete from '../../../services/ReactQuery/useOptimisticDelete';
import useOptimisticUpdate from '../../../services/ReactQuery/useOptimisticUpdate';
import { Link } from 'react-router-dom';

export default function Reward({reward, onDelete, onChange}) {

    const remove = useOptimisticDelete('rewards', id => API.delete(id))
    const toggle = useOptimisticUpdate('rewards', data => API.put(data))

    const handleDelete = () => {
        const confirm = window.confirm('Êtes-vous sûr de vouloir supprimer cette récompense ?');
        if(!confirm) return false;

        return remove.mutate(reward.id)
    }


    return <Card sx={{width: 220, maxWidth: 220, mb: 2, mr: 2}}>

            <CardMedia
                component="img"
                image={reward.picture?.url}
                alt={reward.title}
            />


            <CardContent>
                <Typography gutterBottom variant="h6" component="div">
                    {reward.type?.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {reward.title}
                </Typography>
            </CardContent>

            <CardActions>

                <Stack direction='row' justifyContent='space-between' width='100%'>

                    <Toggle 
                        label='Active' 
                        value={reward.active}
                        onChange={() => 
                            toggle.mutate({...reward, active: !reward.active})
                        }
                    />

                    <Stack direction='row'>

                        <Link to={`/admin/rewards/${reward.id}`}>
                            <Tip type='edit'/>
                        </Link>

                        <Tip type='delete' onClick={handleDelete}/>

                    </Stack>

                </Stack>

            </CardActions>

    </Card>;

}